/* ══════════════════════════════════════════
   CODDIWOMPLE THEME.JS
   ══════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── SCROLL REVEAL ── */
  function initReveal() {
    const els = document.querySelectorAll('[data-reveal], [data-reveal-left], [data-reveal-scale]');
    if (!els.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(el => io.observe(el));
  }

  /* ── HEADER SCROLL SHADOW ── */
  function initHeaderScroll() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ── HERO SLIDESHOW ── */
  function initHero() {
    const hero   = document.querySelector('.hero');
    const slides = document.querySelectorAll('.hero__slide');
    const dots   = document.querySelectorAll('.hero__dot');
    if (!hero || slides.length < 2) {
      if (hero) { hero.classList.add('hero--loaded'); }
      return;
    }

    let cur = 0;
    let timer;

    function go(n) {
      slides[cur].classList.remove('is-active');
      dots[cur]  && dots[cur].classList.remove('is-active');
      cur = (n + slides.length) % slides.length;
      slides[cur].classList.add('is-active');
      dots[cur]  && dots[cur].classList.add('is-active');
    }

    dots.forEach((d, i) => d.addEventListener('click', () => { clearInterval(timer); go(i); timer = setInterval(() => go(cur + 1), 5500); }));
    timer = setInterval(() => go(cur + 1), 5500);

    // entrance animations
    requestAnimationFrame(() => { hero.classList.add('hero--loaded'); });
  }

  /* ── MARQUEE PAUSE ON HOVER ── */
  function initMarquee() {
    document.querySelectorAll('.marquee-track, .announcement-bar__track').forEach(t => {
      t.addEventListener('mouseenter', () => t.style.animationPlayState = 'paused');
      t.addEventListener('mouseleave', () => t.style.animationPlayState = 'running');
    });
  }

  /* ── MOBILE NAV ── */
  function initMobileNav() {
    const hamburger = document.querySelector('.hamburger');
    const mobileNav = document.querySelector('.mobile-nav');
    const mobileClose = document.querySelector('.mobile-nav__close');
    if (!hamburger || !mobileNav) return;

    function open()  { mobileNav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; }

    hamburger.addEventListener('click', open);
    mobileClose && mobileClose.addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }

  /* ══ CART ══ */
  const FREE_SHIP = 150000; // piastres (EGP 1500)

  function money(piastres) {
    return 'EGP ' + (piastres / 100).toLocaleString('en-EG', { minimumFractionDigits: 0 });
  }

  function openCart()  {
    document.getElementById('cartDrawer')?.classList.add('is-open');
    document.getElementById('cartOverlay')?.classList.add('is-open');
    document.getElementById('cartDrawer')?.setAttribute('aria-hidden', 'false');
    document.getElementById('cartOverlay')?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchAndRenderCart();
  }

  function closeCart() {
    document.getElementById('cartDrawer')?.classList.remove('is-open');
    document.getElementById('cartOverlay')?.classList.remove('is-open');
    document.getElementById('cartDrawer')?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  async function fetchAndRenderCart() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      renderCart(cart);
    } catch(e) { console.error(e); }
  }

  function renderCart(cart) {
    const body    = document.getElementById('cartBody');
    const empty   = document.getElementById('cartEmpty');
    const items   = document.getElementById('cartItems');
    const footer  = document.getElementById('cartFooter');
    const total   = document.getElementById('cartTotalPrice');
    const badge   = document.getElementById('cartBadge') || document.querySelector('.cart-badge');
    const shipMsg = document.getElementById('shipMsg');
    const shipFill= document.getElementById('shipFill');

    // Badge
    document.querySelectorAll('.cart-badge').forEach(b => b.textContent = cart.item_count);

    // Ship bar
    if (shipMsg && shipFill) {
      const pct = Math.min(100, (cart.total_price / FREE_SHIP) * 100);
      shipFill.style.width = pct + '%';
      if (cart.total_price >= FREE_SHIP) {
        shipMsg.innerHTML = '🎉 You qualify for <strong>free shipping!</strong>';
      } else {
        const rem = Math.ceil((FREE_SHIP - cart.total_price) / 100);
        shipMsg.innerHTML = `You are <strong>EGP ${rem.toLocaleString()}</strong> away from free shipping.`;
      }
    }

    if (total) total.textContent = money(cart.total_price);

    if (cart.item_count === 0) {
      empty.style.display = 'block';
      items.innerHTML = '';
      if (footer) footer.style.display = 'none';
      return;
    }

    empty.style.display = 'none';
    if (footer) footer.style.display = 'block';

    items.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <img class="cart-item__img"
          src="${item.featured_image?.url ? item.featured_image.url.replace('.jpg','_150x.jpg').replace('.png','_150x.png') : ''}"
          alt="${item.title}" width="80" height="100" loading="lazy">
        <div class="cart-item__info">
          <p class="cart-item__name">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
          <p class="cart-item__price">${money(item.price)}</p>
          <div class="cart-item__qty">
            <button class="qty-dec" data-key="${item.key}" data-qty="${item.quantity}">−</button>
            <span>${item.quantity}</span>
            <button class="qty-inc" data-key="${item.key}" data-qty="${item.quantity}">+</button>
          </div>
        </div>
        <button class="cart-item__remove" data-key="${item.key}" aria-label="Remove">✕</button>
      </div>
    `).join('');

    items.querySelectorAll('.qty-dec').forEach(b => b.addEventListener('click', () => updateItem(b.dataset.key, parseInt(b.dataset.qty) - 1)));
    items.querySelectorAll('.qty-inc').forEach(b => b.addEventListener('click', () => updateItem(b.dataset.key, parseInt(b.dataset.qty) + 1)));
    items.querySelectorAll('.cart-item__remove').forEach(b => b.addEventListener('click', () => updateItem(b.dataset.key, 0)));
  }

  async function updateItem(key, qty) {
    try {
      const cart = await fetch('/cart/change.js', {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(r => r.json());
      renderCart(cart);
    } catch(e) { console.error(e); }
  }

  async function addToCart(variantId, qty = 1) {
    try {
      const cart = await fetch('/cart/add.js', {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ id: variantId, quantity: qty })
      }).then(r => r.json());
      openCart();
      return true;
    } catch(e) { return false; }
  }

  function initCart() {
    const cartToggle = document.getElementById('cartToggle');
    const cartClose  = document.getElementById('cartClose');
    const cartOverlay= document.getElementById('cartOverlay');

    cartToggle  && cartToggle.addEventListener('click', openCart);
    cartClose   && cartClose.addEventListener('click', closeCart);
    cartOverlay && cartOverlay.addEventListener('click', closeCart);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

    // Quick-add buttons on product cards
    document.querySelectorAll('[data-quick-add]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const id = btn.dataset.quickAdd;
        if (!id) return;
        const orig = btn.textContent;
        btn.textContent = 'Adding…'; btn.disabled = true;
        const ok = await addToCart(id);
        btn.textContent = ok ? 'Added!' : orig;
        if (ok) setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1400);
        else btn.disabled = false;
      });
    });
  }

  /* ══ PRODUCT PAGE ══ */
  function initProductPage() {
    if (!document.querySelector('.product-page')) return;

    /* ── Gallery ── */
    const thumbs  = document.querySelectorAll('.gallery-thumb');
    const mains   = document.querySelectorAll('.gallery-main__img');
    const mainWrap= document.querySelector('.gallery-main');
    let activeIdx = 0;

    function showImg(i) {
      thumbs[activeIdx]?.classList.remove('is-active');
      mains[activeIdx]?.classList.remove('is-active');
      activeIdx = i;
      thumbs[i]?.classList.add('is-active');
      mains[i]?.classList.add('is-active');
    }
    thumbs.forEach((t, i) => t.addEventListener('click', () => showImg(i)));

    // Zoom
    const zoomOverlay = document.getElementById('galleryZoom');
    const zoomImg     = document.getElementById('galleryZoomImg');
    const zoomClose   = document.getElementById('galleryZoomClose');
    if (mainWrap && zoomOverlay) {
      mainWrap.addEventListener('click', () => {
        const src = mains[activeIdx]?.src;
        if (!src) return;
        zoomImg.src = src;
        zoomOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
      zoomClose && zoomClose.addEventListener('click', () => {
        zoomOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      });
      zoomOverlay.addEventListener('click', (e) => {
        if (e.target === zoomOverlay) { zoomOverlay.classList.remove('is-open'); document.body.style.overflow = ''; }
      });
    }

    /* ── Size selection ── */
    const sizeBtns  = document.querySelectorAll('.size-btn');
    const addBtn    = document.querySelector('.product-form__add');
    const notifyBtn = document.querySelector('.product-form__notify');
    let selectedVariantId = null;
    let isSoldOut = false;

    sizeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-sold-out')) return;
        sizeBtns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        selectedVariantId = btn.dataset.variantId;
        isSoldOut = false;
        if (addBtn)    { addBtn.style.display = 'block'; addBtn.disabled = false; }
        if (notifyBtn) { notifyBtn.style.display = 'none'; }
        document.querySelector('.notify-form')?.classList.remove('is-open');
      });
    });

    /* ── Add to cart ── */
    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        if (!selectedVariantId) {
          // Shake size grid
          const grid = document.querySelector('.size-grid');
          if (grid) { grid.style.animation = 'shake 0.4s ease'; setTimeout(() => grid.style.animation = '', 400); }
          return;
        }
        const orig = addBtn.textContent;
        addBtn.textContent = 'Adding…'; addBtn.disabled = true;
        const ok = await addToCart(selectedVariantId);
        addBtn.textContent = ok ? 'Added!' : 'Try Again';
        setTimeout(() => { addBtn.textContent = orig; addBtn.disabled = false; }, 1600);
      });
    }

    /* ── Notify me ── */
    if (notifyBtn) {
      notifyBtn.addEventListener('click', () => {
        document.querySelector('.notify-form')?.classList.toggle('is-open');
      });
    }

    /* ── Size chart modal ── */
    const sizeChartBtns    = document.querySelectorAll('.size-chart-btn');
    const sizeChartModal   = document.getElementById('sizeChartModal');
    const sizeChartOverlay = document.getElementById('sizeChartOverlay');
    const sizeChartClose   = document.getElementById('sizeChartClose');

    function openSizeChart() {
      sizeChartModal?.classList.add('is-open');
      sizeChartOverlay?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeSizeChart() {
      sizeChartModal?.classList.remove('is-open');
      sizeChartOverlay?.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    sizeChartBtns.forEach(b => b.addEventListener('click', openSizeChart));
    sizeChartClose  && sizeChartClose.addEventListener('click', closeSizeChart);
    sizeChartOverlay && sizeChartOverlay.addEventListener('click', closeSizeChart);

    /* ── Accordion ── */
    document.querySelectorAll('.accordion-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.accordion-item');
        const wasOpen = item.classList.contains('is-open');
        document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('is-open'));
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }

  /* ── CSS shake keyframe (injected) ── */
  function injectShake() {
    const s = document.createElement('style');
    s.textContent = `@keyframes shake {
      0%,100%{transform:translateX(0)}
      20%{transform:translateX(-6px)}
      40%{transform:translateX(6px)}
      60%{transform:translateX(-4px)}
      80%{transform:translateX(4px)}
    }`;
    document.head.appendChild(s);
  }

  /* ── Newsletter ── */
  function initNewsletter() {
    document.querySelectorAll('.newsletter__form').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const emailInput = form.querySelector('input[type="email"]');
        const successMsg = form.closest('.newsletter')?.querySelector('.newsletter__success');
        if (!emailInput?.value) return;
        // Shopify customer subscribe
        try {
          await fetch('/contact', {
            method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({ form_type: 'customer', 'contact[email]': emailInput.value, 'contact[tags]': 'newsletter' })
          });
        } catch(e) {}
        emailInput.value = '';
        if (successMsg) { successMsg.style.display = 'block'; }
      });
    });
  }

  /* ── INIT ALL ── */
  document.addEventListener('DOMContentLoaded', () => {
    initReveal();
    initHeaderScroll();
    initHero();
    initMarquee();
    initMobileNav();
    initCart();
    initProductPage();
    initNewsletter();
    injectShake();
  });

})();
